export default {
  async fetchCurrentBusiness(axios, token) {
    let business = await axios.get('/api/business/business/current/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    let businessObject = business.data.data.attributes;
    businessObject.id = business.data.data.id;
    return businessObject;
  },
};
